"use client";

import * as React from "react";
import { useState } from "react";
import { Badge } from "@/components/ui/badge";
import { ToggleGroup, ToggleGroupItem } from "@/components/ui/toggle-group";
export default function PricingHero() {
  const [billingCycle, setBillingCycle] = useState<"monthly" | "annual">("annual");
  return <section data-section-id="146816" id="hero" className="bg-background text-foreground py-20 md:py-[120px]">
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8 flex flex-col items-center text-center">
        
        <Badge variant="outline" className="mb-8 rounded-full px-4 py-1.5 border-primary/20 bg-primary/5 text-sm font-medium text-primary shadow-2xs backdrop-blur-sm">
          Consultoria Especialista Linx
        </Badge>

        <h1 className="mb-6 max-w-4xl text-4xl font-bold tracking-tight text-foreground sm:text-5xl md:text-[60px] md:leading-[1.1]">
          Sistemas Linx: Gestão de Alta Performance para o Varejo
        </h1>

        <p className="mb-12 max-w-2xl text-lg text-muted-foreground md:text-xl md:leading-relaxed">
          Potencialize seu varejo com Microvix e e-Millennium. Consultoria técnica especializada, implantação guiada e suporte próximo para transformar sua operação comercial hoje.
        </p>

        <div className="flex items-center justify-center">
          
        </div>

      </div>
    </section>;
}